import { render, staticRenderFns } from "./VTableActionsRow.vue?vue&type=template&id=87d39dea&"
import script from "./VTableActionsRow.vue?vue&type=script&lang=ts&"
export * from "./VTableActionsRow.vue?vue&type=script&lang=ts&"
import style0 from "./VTableActionsRow.vue?vue&type=style&index=0&id=87d39dea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports